import { CloseCircleOutlined } from "@ant-design/icons";
import {
  Button,
  Col,
  Form,
  Input,
  Layout,
  Modal,
  notification,
  Row,
} from "antd";
import moment from "moment";
import "moment/locale/vi";
import React from "react";
import { connect } from "react-redux";
import { withRouter } from "react-router-dom";
import Cookies from "universal-cookie";
import { changePass, logoutURL, userIDURL } from "../constants";
import { logout } from "../store/actions/auth";
import { getUser } from "../store/actions/user";
import { authAxios } from "../utils";

moment.locale("vi");

const cookies = new Cookies();
const { Content } = Layout;

const validateMessages = {
  required: "Vui lòng nhập ${label} !",
  types: {
    email: "${label} không đúng định dạng email!",
    number: "${label} không phải số!",
  },
  number: {
    range: "${label} must be between ${min} and ${max}",
  },
};

const messageBox = (type, title, contents) => {
  notification[type]({
    message: title,
    description: contents,
  });
};

class CustomLayout extends React.Component {
  state = {
    collapsed: false,
    showResults: true,
    currentSelectedKeys: "1",
    currentOpenKeys: "",
    lsNotification: [],
    countNoti: 0,
    modalVisiblePass: false,
    lsMenu: null,
    modalVisibleInfoUser: false,
    passNew_1_Streng: "",
  };

  componentDidMount() {
    this.handleFetchPermissionUserInfo();
    try {
      const currentOpenKeys =
        JSON.parse(localStorage.getItem("currentOpenKeys")) || "";
      const currentSelectedKeys =
        JSON.parse(localStorage.getItem("currentSelectedKeys")) || "";
      this.setState({
        currentOpenKeys,
        currentSelectedKeys,
      });
    } catch (e) {}
    this.setState({ lsMenu: JSON.parse(localStorage.getItem("menu")) });
  }

  handleFetchPermissionUserInfo = () => {
    this.setState({ loading: true });
    authAxios(cookies.get("token"))
      .get(userIDURL)
      .then((res) => {
        const { addUser, addPermission } = this.props;
        addUser(res.data);
        addPermission(res.data.permission);
        this.setState({ lsMenu: JSON.parse(localStorage.getItem("menu")) });
        this.setState({
          loading: false,
          username: res.data.username,
          userId: res.data.userId,
          avatar_url: res.data.avatar_url,
          view_user: res.data.permission.view_user,
        });
      })
      .catch((err) => {
        this.setState({ error: err, loading: false });
      });
  };

  logout_new = (e) => {
    authAxios(cookies.get("token"))
      .get(logoutURL)
      .then((res) => {
        window.location = "/login";
      });
    logout();
  };
  onCollapse = (collapsed) => {
    this.setState({ collapsed });
  };

  fetchApiChangePass = (params = {}) => {
    this.setState({ loading: true });
    var FormData = require("form-data");
    var data = new FormData();
    data.append("user_id", this.state.userId);
    data.append("pass_old", params.pass_old);
    data.append("pass_new1", params.pass_new1);
    data.append("pass_new2", params.pass_new2);

    authAxios(cookies.get("token"))
      .post(changePass, data)
      .then((res) => {
        if (res.data.error) {
          const dataError = Object.entries(res.data.error).map(
            ([key, value]) => value
          );
          messageBox("error", "Lỗi", dataError);
          this.setState({ modalVisiblePass: false });
        } else {
          messageBox("success", "Thông báo", "Đổi mật khẩu thành công.");
          this.setState({ modalVisiblePass: true });
          this.logout_new();
        }
        this.setState({ loading: false });
      })
      .catch((err) => {
        console.log(err);
      });
  };

  onFinishChangePass = (values) => {
    if (
      /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?=.*[~`!@#$%^&*()])[A-Za-z\d~`!@#$%^&*()]{9,}$/.test(
        values.passNew_1
      ) == false
    ) {
      messageBox("error", "Lỗi", "Mật khẩu không hợp lệ.");
      return;
    } else {
      this.setState({ loading: true });
      this.fetchApiChangePass({
        pass_old: values.passOLD,
        pass_new1: values.passNew_1,
        pass_new2: values.passNew_2,
      });
    }
  };

  handleModalCancel_1 = () => {
    this.setState({ modalVisiblePass: false });
  };

  ChangePass = (modalVisiblePass) => {
    return (
      <Modal
        destroyOnClose
        title="Đổi mật khẩu"
        open={modalVisiblePass}
        onCancel={this.handleModalCancel_1}
        footer={null}
        closeIcon={<CloseCircleOutlined title="Thoát (ESC)" />}
        keyboard
        width={800}
      >
        <Form
          onFinish={(values) => this.onFinishChangePass(values)}
          validateMessages={validateMessages}
          layout="vertical"
        >
          <Col sm={15} offset={3}>
            <Form.Item
              name="passOLD"
              rules={[
                {
                  required: true,
                },
              ]}
              label={"Nhập mật khẩu cũ"}
            >
              <Input.Password />
            </Form.Item>
          </Col>
          <Col sm={15} offset={3}>
            <Form.Item
              name="passNew_1"
              rules={[
                {
                  required: true,
                },
              ]}
              label={"Nhập mật khẩu mới"}
            >
              <Input.Password />
            </Form.Item>
          </Col>
          <Col sm={15} offset={3}>
            <Form.Item
              name="passNew_2"
              label={"Nhập lại mật khẩu mới"}
              dependencies={["passNew_1"]}
              hasFeedback
              rules={[
                {
                  required: true,
                },
                ({ getFieldValue }) => ({
                  validator(_, value) {
                    if (!value || getFieldValue("passNew_1") === value) {
                      return Promise.resolve();
                    }
                    return Promise.reject(
                      new Error("Hai mật khẩu bạn đã nhập không khớp!")
                    );
                  },
                }),
              ]}
            >
              <Input.Password />
            </Form.Item>
          </Col>
          <Row style={{ paddingBottom: "5px" }}>
            <Col span={24} style={{ textAlign: "center" }}>
              <Button
                shape="round"
                size="default"
                type="primary"
                htmlType="submit"
              >
                Đổi mật khẩu
              </Button>
            </Col>
          </Row>
        </Form>
        <Row>
          <h4 style={{ color: "#a91c1c" }}>Lưu ý: </h4>
          <h4 style={{ color: "#73879C" }}>
            &nbsp;Mật khẩu phải ít nhất 9 ký tự bao gồm chữ hoa, chữ thường, số
            và ký tự đặt biệt.
          </h4>
        </Row>
      </Modal>
    );
  };

  render() {
    const { authenticated } = this.props;
    return authenticated ? (
      <Layout>
        <Layout className="site-layout" style={{ minHeight: "100vh" }}>
          <Content>{this.props.children}</Content>
        </Layout>
      </Layout>
    ) : (
      ""
    );
  }
}

const mapStateToProps = (state) => {
  return {
    authenticated: state.auth.token !== null,
    permission: state.user.permission,
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    logout: () => dispatch(logout()),
    addUser: (user) => dispatch(getUser(user)),
  };
};

export default withRouter(
  connect(mapStateToProps, mapDispatchToProps)(CustomLayout)
);
